import { $Q } from './query-selector'
import { stringToHTML } from './to-html';

/**
 * Update the width of bar progress
 * @param {DOM element} input - input hidde with data
 */
export const barProgress = (container) => {
  const input = $Q('.progress-bar-data');
  
  if(!input) return;

  const totalPrice = parseFloat(input.dataset.total) / 100;
  const limitPrice = parseInt(input.dataset.limit);
  const progress = $Q('.bar-progress');
  if (!progress) return null;

  const barWidth = totalPrice / limitPrice * 100;

  if (barWidth > 100) {
    progress.style.width = "100%";
  } else {
    progress.style.width = `${barWidth}%`;
  }
}

export const updateBarProgress = (str) => {
  const updateContent = $Q(".progress-bar__container", stringToHTML(str)); 

  const input = updateContent.querySelector('.progress-bar-data');

  if(!input) return;

  const totalPrice = parseFloat(input.dataset.total) / 100;
  const limitPrice = parseInt(input.dataset.limit);
  const progress = updateContent.querySelector('.bar-progress');

  if (!progress) return null;

  const barWidth = totalPrice / limitPrice * 100;

  if (barWidth > 100) {
    progress.style.width = "100%";
  } else {
    progress.style.width = `${barWidth}%`;
  }

  $Q(".progress-bar__container").innerHTML = updateContent.outerHTML;
};
